import { type FC } from 'react';
import { CircularProgress } from '@mui/material';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

export type LoadingPageProps = {};

export const LoadingPage: FC<LoadingPageProps> = () => (
  <CenteredLayout vertical horizontal>
    <CircularProgress />
  </CenteredLayout>
);
